module.exports = {
    data () {
        return {
            vatTypes: [],
        };
    },

    watch: {
        "form.total": function () {
            this.fillFormDetails();
        },
        "form.vat_type": function () {
            this.fillFormDetails();
        },
        "form.includes_vat": function () {
            this.fillFormDetails();
        },
        "form.vat": function () {
            this.fillFormDetails();
        }
    },

    mounted () {
        if (this.hasFeature("release_vat_updates")) {
            this.vatTypes = this.state.vat_percentages.map(vat => {
                    return {
                        key: vat.key.replace("_default", ""),
                        value: vat.value
                    };
                }
            );
        } else {
            this.vatTypes = [
                {key: "no_vat", value: "No VAT"},
                {key: "15_percent_rate", value: "15% Standard Rate"},
                {key: "custom", value: "Custom"},
            ];
        }
    },

    methods: {
        fillFormDetails () {
            this.form.vat = this.calculateVat(this.form.total, this.form.includes_vat, this.form.vat_type);

            if (("amount" in this.form)) {
                if (this.form.total && this.form.vat) {
                    this.form.amount = (this.form.total - this.form.vat).toFixed(2);
                } else {
                    this.form.amount = this.form.total;
                }
            }
        },

        calculateVat (amount, isIncludingVat, vatType) {
            if (isNaN(amount)) {
                return 0;
            }

            let vatPercentage = 0;

            if (this.hasFeature("release_vat_updates")) {
                switch (vatType) {
                    case "custom":
                        return this.form.vat;
                    case "0%":
                        return 0;
                    default:
                        let foundRate = this.state.vat_percentages.find(vat => vat.value === vatType);
                        if (foundRate) {
                            vatPercentage = foundRate.value / 100;
                        }
                }
            } else {
                if (vatType === "custom") {
                    return this.form.vat;
                }

                if (vatType === "no_vat") {
                    return 0;
                }

                if (vatType === "vat_adjustment") {
                    return amount;
                }

                if (vatType === "14_percent_rate") {
                    vatPercentage = 0.14;
                } else if (vatType === "15_percent_rate") {
                    vatPercentage = 0.15;
                }
            }

            if (isIncludingVat) {
                let amountExcludingVat = (amount * (1 / (1 + vatPercentage))).toFixed(2);
                return (amount - amountExcludingVat).toFixed(2);
            } else {
                let amountIncludingVat = (amount * (1 + vatPercentage)).toFixed(2);
                return (amountIncludingVat - amount).toFixed(2);
            }
        },
    },
};
